<script lang="ts" setup>
import { LocalStorage } from '~/models/browser-storage'

const currentStep = ref<number>(1)
const privacyStatementAccepted = ref<boolean>(false)

const modalStore = useModalManager()
const route = useRoute()
const currentPharmacyStore = useCurrentPharmacyStore()
const { t } = useTranslation()
const { isDesktop } = useDevice()

const { isProd } = useEnvs()

const basePath = computed(() => isProd.value ? 'https://ihreapotheken.de' : 'https://qa.ihreapotheken.de')

const areChatTermsAccepted = useLocalStorage<boolean>(LocalStorage.isAgreementForChatUsageAccepted, privacyStatementAccepted)

onMounted(() => {
  privacyStatementAccepted.value = areChatTermsAccepted.value
  if (privacyStatementAccepted.value) {
    currentStep.value = 2
  }
})

const openChatIframe = () => {
  currentStep.value = 2
  areChatTermsAccepted.value = true
}

const closeChatModal = () => modalStore.chatModalVisible = false

const chatIframeUrl = computed(() => `https://chat.apotheken.de/?client=Apothekerkunde&secureid=${currentPharmacyStore.pharmacySecureId}&disableUpload=true&parenturl=${basePath.value}${route.fullPath}`)

// manually disable scroll when modal is visible
watch(() => modalStore.chatModalVisible, (value) => {
  if (!value) {
    document.documentElement.style.overflow = 'auto'
  } else {
    document.documentElement.style.overflow = 'hidden'
  }
})
</script>

<template>
  <div
    class="w-screen h-screen fixed top-0 left-0 bg-backgroundOverlay z-modal"
    :class="{ invisible: !modalStore.chatModalVisible }"
    @click="closeChatModal"
  >
    <div class="lt-md:h-screen lt-md:w-full lt-md:flex lt-md:flex-col sm:absolute sm:bottom-5 sm:right-5 bg-white rounded">
      <div class="chat-box-header flex items-center justify-center py-3 w-full ">
        <div class="text-grey-800 font-700 text-md">
          {{ t('chat.title') }}
        </div>

        <i
          class=" i-fas:xmark w-4 h-4 absolute top-4 right-3 text-grey-400 hover:text-black cursor-pointer"
          @click="closeChatModal"
        ></i>
      </div>
      <div
        v-if="currentStep === 1"
        class="flex grow flex-col p-3 justify-between"
        :class="{ 'chat-box': isDesktop }"
      >
        <IaCheckbox
          v-model="privacyStatementAccepted"
          :label="t('chat.acceptTerms')"
          float-up
          class="text-left mt-3"
        />
        <div>
          <IaAlert
            type="info"
            full-width
            class="ia-block text-left"
          >
            {{ t('chat.info') }}
          </IaAlert>
          <IaButton
            class="w-full mt-3"
            :disabled="!privacyStatementAccepted"
            @click="openChatIframe"
          >
            {{ t('chat.buttonText') }}
          </IaButton>
        </div>
      </div>
      <iframe
        v-if="currentStep === 2"
        :src="chatIframeUrl"
        class="w-full h-full lt-md:flex lt-md:grow"
        :class="{ 'chat-box': isDesktop }"
        scrolling="no"
      ></iframe>
    </div>
 </div>
</template>

<style scoped lang="postcss">
  .chat-box-header {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
    z-index: 50;
    position: relative;
  }
  .chat-box {
    height: 567px !important;
    width: 340px !important;
  }
</style>
